import { render, staticRenderFns } from "./Test7.vue?vue&type=template&id=0e783ea2&"
import script from "./Test7.vue?vue&type=script&lang=js&"
export * from "./Test7.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports